import { deltaTransformPoint } from "./deltaTransformPoint";

export function decomposeMatrix(matrix: DOMMatrix) {
  // @see https://gist.github.com/2052247

  // calculate delta transform point
  const px = deltaTransformPoint(matrix, { x: 0, y: 1 });
  const py = deltaTransformPoint(matrix, { x: 1, y: 0 });

  // calculate skew
  const skewX = (180 / Math.PI) * Math.atan2(px.y, px.x) - 90;
  const skewY = (180 / Math.PI) * Math.atan2(py.y, py.x);

  return {
    translateX: matrix.e,
    translateY: matrix.f,
    scaleX: Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b),
    scaleY: Math.sqrt(matrix.c * matrix.c + matrix.d * matrix.d),
    skewX: skewX,
    skewY: skewY,
    rotation: skewX // rotation is the same as skew x
  };
}
